import { useId } from "react";

import styles from "./styles.module.css";

export default function TextArea({
  id,
  label,
  placeholder,
  onChange,
  value,
  errors,
  ...textareaProps
}) {
  const inputId = id ?? `tf-${useId()}`;

  return (
    <div className={styles.formElement}>
      {label && (
        <label htmlFor={inputId}>{label}</label>
      )}
      <div>
        <textarea
          className={styles.textarea}
          placeholder={placeholder}
          id={inputId}
          {...textareaProps}
        >
          {value}
        </textarea>
        {errors && (
          <ul className="errorsContainer">
            {errors.map(errorMessage => (
              <li>{errorMessage}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
